import { mapState, mapMutations } from 'vuex';
export default {
  computed: {
    ...mapState('account', {
      globalUserInfo: (state) => state.userInfo,
    }),
  },
  watch: {
    globalUserInfo: {
      handler (val, oldVal) {
        console.log('globalUserInfo changed', val, oldVal)
        if (!val || !val.game_account) return
        if (val.game_account !== oldVal.game_account) {
          this.getUserInfo()
          this.onChangeAccount()
        }
      },
      deep: true
    }
  },
  methods: {
    ...mapMutations('app', {
      CHANGE_BIND_ACCOUNT_DIALOG: 'CHANGE_BIND_ACCOUNT_DIALOG',
    }),
    onLogswitch () {
      const options = typeof this.getBindAccountDialogOptions === 'function'
        ? this.getBindAccountDialogOptions()
        : {}
      this.CHANGE_BIND_ACCOUNT_DIALOG({
        ...options,
        visible: true,
        isSwitchAccount: true,
      });
    },
    getUserInfo () {},
    // 变更用户信息后需要更新的内容
    onChangeAccount () {},

    // 用户绑定前获取用户信息
  }
}
